import api from "../../../services/api";
import { IRentedPropertyPhoto } from "../types/ownerDashboard.types";
import { normalizeRentedPropertyPhotos } from "../utils/normalizeRentedPropertyPhotos";

const MAX_LISTING_PHOTOS = 5;

function asPropertyRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return null;
  }

  const record = value as Record<string, unknown>;

  if (
    record.data &&
    typeof record.data === "object" &&
    !Array.isArray(record.data)
  ) {
    return record.data as Record<string, unknown>;
  }

  return record;
}

function asPositivePropertyId(value: unknown): number | null {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

async function fetchPropertyRecord(
  propertyId: number
): Promise<Record<string, unknown> | null> {
  const response = await api.get(`/api/client/properties/${propertyId}`);
  return asPropertyRecord(response.data);
}

function sliceListingPhotos(photos: IRentedPropertyPhoto[]): IRentedPropertyPhoto[] {
  return photos.slice(0, MAX_LISTING_PHOTOS);
}

export async function fetchRentedPropertyListingPhotos(
  propertyId: number
): Promise<IRentedPropertyPhoto[]> {
  const property = await fetchPropertyRecord(propertyId);
  if (!property) {
    return [];
  }

  const directPhotos = sliceListingPhotos(
    normalizeRentedPropertyPhotos(property.photos)
  );
  if (directPhotos.length > 0) {
    return directPhotos;
  }

  const parentPropertyId = asPositivePropertyId(property.parent_property_id);
  if (parentPropertyId == null || parentPropertyId === propertyId) {
    return [];
  }

  const parentProperty = await fetchPropertyRecord(parentPropertyId);
  if (!parentProperty) {
    return [];
  }

  return sliceListingPhotos(normalizeRentedPropertyPhotos(parentProperty.photos));
}
